(function (angular) {
    'use strict';

    angular.module('app')
        .controller('manageGroup', manageGroup);

    manageGroup.$inject = [
        '$rootScope',
        '$uibModalInstance',
        'UsersApi',
        'GroupsApi',
        'Group',
        'UploadsApi',
        'handleError',
        '$uibModal',
        'groupId',
        'confirmDialog',

    ];

    function manageGroup(
        $rootScope,
        $uibModalInstance,
        UsersApi,
        GroupsApi,
        Group,
        UploadsApi,
        handleError,
        $uibModal,
        groupId,
        confirmDialog
    ) {
        var vm = this;

        // vm.permissionChecks = {
        //     canDelete: groupPolicy.canDelete(),
        // };

        vm.group = {
            status: 'pending',
            description: '<p><br></p>',
            private: false,
            settings: {
                hide_attendees: false,
            },
        };
        vm.createNewGroup = !Group;
        vm.isLoading = false;
        vm.thisUser = $rootScope.thisUser;
        vm.groupUser = null;

        vm.addUserData = {
            user_id: null,
        };
        vm.close = close;
        vm.deletGroup = deletGroup;
        vm.getOneGroup = getOneGroup;
        vm.getGroup = getGroup;
        vm.pickGroupUser = pickGroupUser;
        vm.deleteGroup = deleteGroup;
        vm.updateGroup = updateGroup;
        vm.handleImage = handleImage;
        vm.handleImageError = handleImageError;
        vm.handleDescriptionChange = handleDescriptionChange;


        vm.imageUploadOptions = {
            resize: true,
            resizeShape: 'rectangle',
            resizeSize: {
                w: 1140,
                h: 400,
            },
            resizeAspectRatio: 2.85,
        };

        vm.image = {
            data: null,
            uploaded: false,
        };

        /**
         * Initiates this controller
         */
        function init() {
            // get featured member
            if (vm.settings.group_user_id) {
                getGroupUser(vm.settings.group_user_id);
            }

        }

        /**
         * Retrieves the featured member from the API and adds to scope for rendering
         * @param  {int} id - ID of member
         * @return {void}
         */
        function getGroupUser(id) {
            UsersApi.get({
                id,
            }, response => {
                vm.groupUser = response.data;
            });
        }

        /**
         * Shows modal that lets the admin search and pick a featured member
         * @return {void}
         */
        function pickGroupUser() {
            $uibModal.open({
                templateUrl: 'modals/admin-pick-group-user.html',
                controller: 'manageGroupUsersController',
                controllerAs: 'vm',
                windowClass: 'pick-group-user',
                resolve: {
                    group: () => vm.group,
                },
            });
        }

        /**
         * Handles the image chosen by the user
         *
         * @param  {string} file - base64 image
         * @return {void}
         */
        function handleImage(file) {
            vm.image.data = file;
            vm.image.uploaded = false;
        }

        /**
         * Shows file errors
         * @param  {object} imageError - provided as  {image: '[error msg]'}
         * @return {void}
         */
        function handleImageError(imageError) {
            vm.formErrors = angular.merge(vm.formErrors, imageError);
        }

        /**
         * Uploads the banner image if it has been changed.
         *
         * @returns {Promise<Record<string, any>>} The updated group.
         */
        async function saveImage(): Promise<Record<string, any>|void> {
            const promise = new Promise<Record<string, any>|void>(resolve => {
                if (!vm.image.data || vm.image.uploaded) {
                    // No image set, or already uploaded. No need to do anything.
                    return resolve();
                }

                async function handleUploadSuccess(result: { path: string, src: string }): Promise<void> {
                    if (result && result.path) {
                        // update group and save
                        vm.group.img = result.path;

                        return resolve();
                    } else {
                        throw new Error('Invalid response from image upload endpoint.');
                    }
                }

                const handleUploadError = (err: any): void => {
                    throw(err);
                };

                const handleUploadProgress = (progress: number): void => {
                    vm.isLoadingProgress = progress;

                    if (progress === 100) {
                        vm.isLoadingProgress = 0;
                        vm.isLoadingMessage = 'Saving image...';
                    }
                };

                vm.isLoadingMessage = 'Uploading image...';
                UploadsApi
                    .uploadFile(vm.image.data, 'site')
                    .then(handleUploadSuccess, handleUploadError, handleUploadProgress);
            });

            return promise;
        }

        /**
         * Deletes the event and closes the modal
         * @return {void}
         */
        function deleteGroup() {
            confirmDialog('Are you sure you want to delete this group?')
                .result.then(confirm => {
                    if (confirm) {
                        vm.isLoadingMessage = 'Deleting...';
                        vm.isLoading = true;

                        GroupsApi.delete({
                            id: vm.group.id,
                        }, function handleDeleteGroupResponse() {
                            vm.forceClose = true;
                            $uibModalInstance.dismiss('deleted');
                        }, function handleGroupError() {
                            vm.isLoading = false;
                        });
                    }
                });
        }

        /**
         * Modifies group model from the server with any changes we need in our controller.
         *
         *
         * @param {Record<string, any>} group
         * @returns {Record<string, any>} transformed group
         */
        function transformGroup(group: Record<string, any>): Record<string, any> {
            return {
                ...group,
                private: +group.private,
            };
        }

        /**
         * Updates the group description
         *
         * @param {string} description html
         * @returns {void}
         */
        function handleDescriptionChange(description) {
            vm.group.description = description;
        }

        /**
         * Close the modal window.
         *
         * @return {void}
         */
        function close() {
            $uibModalInstance.close();
        }

        /**
         * Delete the group.
         *
         * @return {void}
         */
        function deletGroup() {
            GroupsApi.delete({ Group }, function () {
                vm.isLoading = false;
                $uibModalInstance.close();
            }, function () {
                vm.isLoading = false;
            });
        }

        /**
         * Get the group.
         *
         * @return {void}
         */
        function getOneGroup() {
            vm.isLoading = true;

            GroupsApi.get({ id: groupId }, function (group) {
                vm.group = group.data;
                vm.isLoading = false;
            }, function () {
                vm.isLoading = false;
            });
        }

        /**
         * Loads a group to be edited
         *
         * @return {void}
         */
        function getGroup() {
            vm.isLoadingMessage = 'Loading group...';
            vm.isLoading = true;

            GroupsApi.get({
                id: vm.groupId,
                with: 'users',
            }, response => {
                vm.group = transformGroup(response.data);
                vm.isLoading = false;
            }, err => {
                vm.isLoading = false;
                handleError(err);
            });
        }

        /**
         * Save the group.
         *
         * @return {void}
         */
        function updateGroup() {
            vm.isLoading = true;

            if (groupId === null) {
                saveImage().then (
                  function () {
                    GroupsApi.save({
                        title: vm.group.title,
                        description: vm.group.description,
                        img: vm.group.img,
                        privacy:vm.group.privacy,
                        show_members:vm.group.show_members

                    }, async function () {
                     vm.isLoading = false;
                     $uibModalInstance.close();
                    }, function () {
                      vm.isLoading = false;
                    });
                  }
                );
              } else {
                saveImage().then(
                    function () {
                      GroupsApi.update(vm.group, function () {
                        vm.isLoading = false;
                        $uibModalInstance.close();
                      }, function () {
                        vm.isLoading = false;
                      });
                    }
                );
              }
        }

        if (!vm.createNewGroup) {
            vm.getOneGroup();
        }
    }
}(angular));
